<div fxLayout="row" fxLayoutAlign="end end" >
    <mat-icon style="cursor: pointer;" (click)="closePopup()">close</mat-icon>
</div>
<div mat-dialog-content fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px">
    <h2><mat-icon style="color:#00BA34;font-size: 50px;">check_circle</mat-icon></h2>
    <h3>Congratulations!</h3>
    <div fxLayout="column" fxLayoutAlign="center center" >
        <label mat-dialog-title class="submit-label">Your changes have been submitted successfully.</label>
       
    </div>
    
    
    
</div>